import "./constants";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppRoot from "./App";
import { createBrowserRouter, RouterProvider } from "react-router";
// import reportWebVitals from './reportWebVitals';
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import CollegeSponsors from "./CollegeSponsors";
import { Meetings } from "./meetings/Meetings";
import Archives from "./Archives";
import Main from "./Main";
import MemberList from "./MemberList";
import CollegeSponsorshipPayment from "./CollegeSponsorshipPayment";
import Newsletter from "./Newsletter";
import Officers from "./Officers";
import Membership from "./Membership";
import IndustrySponsors from "./IndustrySponsors";
import IndustrySponsorPayment from "./IndustrySponsorPayment";
import Jobs from "./Jobs";
import Links from "./Links";
import FormsFiles from "./FormsFiles";
import SharedResources from "./resource/SharedResources";
import UploadResource from "./resource/UploadResource";
import Transactions from "./Transactions";
import Admin from "./admin/Admin";
import Notifications from "./admin/notification/Notifications";
import PaymentAudit from "./admin/members/PaymentAudit";
import MailPayment from "./MailPayment";
import OnlinePayment from "./OnlinePayment";
import ErrorElement from "./ErrorElement";
import JobsEdit from "./jobs/JobsEdit";
import Registration from "./conference/Registration";
import Confirmation from "./conference/Confirmation";
import Conference from "./conference/Conference";
import AccountInfo from "./membership/AccountInfo";
import ForgotPasswordEmail from "./membership/ForgotPasswordEmail";
import ResetPassword from "./membership/ResetPassword";
import JobsEditList from "./jobs/JobsEditList";
import AttendeeData from "./admin/conference/AttendeeData";
import SponsorRegistration from "./conference/SponsorRegistration";

const router = createBrowserRouter([
    {
        path: "/",
        Component: AppRoot,
        errorElement: <ErrorElement />,
        children: [
            {
                index: true,
                Component: Main,
            },
            {
                path: "membership",
                children: [
                    {
                        index: true,
                        Component: Membership,
                    },
                    {
                        path: "mailpayment",
                        Component: MailPayment,
                    },
                    {
                        path: "onlinepayment",
                        Component: OnlinePayment,
                    },
                ],
            },
            {
                path: "meetings",
                Component: Meetings,
            },
            {
                path: "conference",
                children: [
                    {
                        index: true,
                        Component: Conference,
                    },
                    {
                        path: "register",
                        Component: Registration,
                    },
                    {
                        path: "confirmation",
                        Component: Confirmation,
                    },
                    {
                        path: "sponsor",
                        children: [
                            {
                                path: "register",
                                Component: SponsorRegistration,
                            },
                        ],
                    },
                ],
            },
            {
                path: "officers",
                Component: Officers,
            },
            {
                path: "college",
                children: [
                    {
                        index: true,
                        Component: CollegeSponsors,
                    },
                    {
                        path: "payment",
                        Component: CollegeSponsorshipPayment,
                    },
                ],
            },
            {
                path: "industrial",
                children: [
                    {
                        index: true,
                        Component: IndustrySponsors,
                    },
                    {
                        path: "payment",
                        Component: IndustrySponsorPayment,
                    },
                ],
            },
            {
                path: "archives",
                Component: Archives,
            },
            {
                path: "listmembers",
                Component: MemberList,
            },

            {
                path: "newsletter",
                Component: Newsletter,
            },
            {
                path: "jobs",
                children: [
                    {
                        index: true,
                        Component: Jobs,
                    },
                    {
                        path: "edit",
                        children: [
                            {
                                index: true,
                                Component: JobsEditList,
                            },
                            {
                                path: ":jobId",
                                Component: JobsEdit,
                            },
                        ],
                    },
                ],
            },

            {
                path: "links",
                Component: Links,
            },
            {
                path: "memberInfo",
                Component: AccountInfo,
            },
            {
                path: "forms",
                Component: FormsFiles,
            },
            {
                path: "resources",
                Component: SharedResources,
            },
            {
                path: "upload",
                Component: UploadResource,
            },
            {
                path: "transactions",
                Component: Transactions,
            },
            {
                path: "admin",
                children: [
                    {
                        index: true,
                        Component: Admin,
                    },
                    {
                        path: "notifications",
                        Component: Notifications,
                    },
                    {
                        path: "paymentaudit",
                        Component: PaymentAudit,
                    },
                    {
                        path: "attendeedata",
                        Component: AttendeeData,
                    },
                ],
            },

            {
                path: "forgotpassword",
                element: <ForgotPasswordEmail />,
            },
            {
                path: "resetpassword/:code",
                children: [
                  {
                    path: ":code",
                    Component: ResetPassword,
                  }
                ]
            },
        ],
    },
]);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <>
        <React.StrictMode>
            <style>{`html {overflow:hidden}`}</style>
            {/* <AuthProvider {...oidcConfig}> */}
            <RouterProvider router={router} />
            {/* </AuthProvider> */}
        </React.StrictMode>
    </>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
